import React from 'react';
import Firebase from '../firebaseComponents';

function getKey(record) {
  return Object.keys(record)[0];
}
class Queries extends Firebase {
  constructor(props) {
    super(props);
    this._collect = this._collect.bind(this);
    this._read = this._read.bind(this);
    this._update = this._update.bind(this);

    this.fetchRecord = this.fetchRecord.bind(this);

    this.fetchDestructionRecords = this.fetchDestructionRecords.bind(this);
    this.updateDestructionRecord = this.updateDestructionRecord.bind(this);
    this.fetchWarrantyRecords = this.fetchWarrantyRecords.bind(this);
    this.updateWarrantyRecord = this.updateWarrantyRecord.bind(this);
    this.fetchWastageRecords = this.fetchWastageRecords.bind(this);
    this.updateWastageRecord = this.updateWastageRecord.bind(this);

    this.approveDestructionRecord = this.approveDestructionRecord.bind(this);
    this.approveWarrantyRecord = this.approveWarrantyRecord.bind(this);
    this.approveWastageRecord = this.approveWastageRecord.bind(this);
    this.approveWastageFinal = this.approveWastageFinal.bind(this);

    this.fetchWarrantyRecordById = this.fetchWarrantyRecordById.bind(this);
    this.fetchWastageRecordById = this.fetchWastageRecordById.bind(this);
    this.fetchDestructionRecordById = this.fetchDestructionRecordById.bind(this);
  }

  _collect(coll) {
    const res = [];
    coll.forEach(snapshot => {
      res.push(Object.assign({}, { _id: snapshot.key }, snapshot.val()))
    })
    return res
  }

  _read(endpoint) {
    return this.db.ref(endpoint).once('value') //TODO: paging/realtime
      .then(this._collect);
  }

  _update(endpoint, recordId, patch) {
    const updates = Object.entries(patch)
      .reduce((acc, [key, value]) =>
        Object.assign(acc, { [`${recordId}/${key}`]: value }) //TODO: will need to adjust if we need to edit nested fields
      , {});
    return this.db.ref(endpoint).update(updates);
  }

  fetchRecord(collection, recordId) {
    return this.db.ref(`${ collection }/${ recordId }`).once('value')
      .then(snapshot => Object.assign({ _id: snapshot.key }, snapshot.val()));
  }

  fetchWarrantyRecordById(recordId) {
    return this._read('/limited_warranty_form/' + recordId);
  }

  fetchWarrantyRecords() {
    return this._read('/limited_warranty_form');
  }

  updateWarrantyRecord(recordId, patch) {
    return this._update('/limited_warranty_form', recordId, patch);
  }

  approveWarrantyRecord(recordId, isDenied=false){
    return this._update('/limited_warranty_form', recordId, isDenied ? { 'warrantyDenied': true } : { 'warrantyApproved': true });
  }

  fetchDestructionRecordById(recordId) {
    return this._read('/certificate_of_destruction_form/' + recordId);
  }

  fetchDestructionRecords() {
    return this._read('/certificate_of_destruction_form');
  }

  updateDestructionRecord(recordId, patch) {
    return this._update('/certificate_of_destruction_form', recordId, patch);
  }

  approveDestructionRecord(recordId)  {
    return Promise.all([
      this._update('/certificate_of_destruction_form', recordId, { 'destructionApproved': true }),
      this.db.ref('/wastage_replacement_form')
        .orderByChild('destructionFormId')
        .equalTo(recordId)
        .once('value')
        .then(snapshot => {
          if(!snapshot.exists()) throw new Error('No Record Match');
          return snapshot;
        })
        .then(snapshot => snapshot.val())
        .then(snapshot => this.db.ref('/wastage_replacement_form/' + getKey(snapshot)).update({ 'destructionApproved': true }))
        .catch(e => console.error(e))
    ]);
  }

  fetchWastageRecordById(recordId) {
    return this._read('/wastage_replacement_form/' + recordId);
  }

  fetchWastageRecords() {
    return this._read('/wastage_replacement_form');
  }

  updateWastageRecord(recordId, patch) {
    return this._update('/wastage_replacement_form', recordId, patch);
  }

  approveWastageRecord(recordId, isDenied=false){
    return this._update('/wastage_replacement_form', recordId, isDenied ? { wastageDenied: true } : { 'wastageApproved': true });
  }

  approveWastageFinal(recordId){
    return this._update('/wastage_replacement_form', recordId, { 'finalApproved': true });
  }
}
const models = new Queries();
export function withModels(Cmp) {
  return  props => <Cmp models={ models } { ...props } />
}

export default Queries;
